import React from 'react';
import AboutOne from '../../components/About/AboutOne';
import aboutImage from '../../assets/images/shapes/about-one-shape-1.png';
import aboutImg1 from '../../assets/images/resources/about-one-img-1.jpg';
import aboutImg2 from '../../assets/images/resources/about-one-img-2.jpg';

const About = () => {
    return (
        <>
            {/* About One Start */}
            <AboutOne 
                className="about-one"
                tagline="About Us"
                title="Where Learning Meets Real Film Production"
                description="Sunrising Cinevision is a complete creative platform offering professional training and high-quality production services. From Acting, Direction, and Cinematography to Film Production, Podcast Studio, Chroma Shoots, and Event Coverage — we provide real-world experience that transforms passion into a successful career."
                
                images={{
                    shapeImage: aboutImage,
                    photo1: aboutImg1,
                    photo2: aboutImg2,
                }}

                trustedCount={100}
                trustedText="Students & Projects Completed"

                linkTo="/about"
                buttonText="Explore More"

                containerClass="container"

                imgAltTexts={{
                    photo1: "Film production training",
                    photo2: "Professional shoot setup",
                }}
            />
            {/* About One End */}
        </>
    );
}

export default About;